import { createWebSocketStore } from 'src/components/#services/helpers';
import { isLoggedIn } from 'src/services/auth';
export const userIsAdmin = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'admin_getMyRole',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
isLoggedIn.subscribe((value) => {
    userIsAdmin.reset();
    if (value) {
        userIsAdmin.send();
    }
});
